window.TYPO3.lang = window.TYPO3.lang || {};

function localize(key, fallback) {
  if (!window.TYPO3.lang[key]) {
    return fallback;
  }
  return window.TYPO3.lang[key];
}

export { localize as Localize };
